import { PreguntaBase } from './preguntabase.model';

export class DropdownPregunta extends PreguntaBase<string> {

  controlType = 'dropdown';
  options: {key: string, value: string, selected: number}[] = [];

  constructor(options: {} = {}) {
    super(options);
    this.options = options['options'] || [];
  }
}



// WEBPACK FOOTER //
// ./src/app/_models/preguntabase-dropdown.model.ts